import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const messageBodyTextStyles = {
  container: css`
    margin-right: ${theme.spacing(0.5)};
    text-align: left;

    .mention-loading {
      padding: ${theme.spacing(0, 0.5)};
    }
  `,

  link: css`
    color: ${theme.colors.primary50};
    text-decoration: underline;

    &:hover {
      color: ${theme.colors.primary60};
    }
  `,
};
